import React, { useEffect } from "react";
import { Image } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { MainLoader } from 'CommonComponent';
import { isEmpty } from 'lodash';
import { logout } from 'actions';

const TopNav = () => {

  const session = useSelector(state => state.session);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!session.loggedIn || isEmpty(session.user)) {
      navigate('/login');
    }
    else{

      // Function to check token expiration and logout
      const checkTokenExpiration = () => { 
        const token = localStorage.getItem('token');
        const expiration_at = localStorage.getItem('expiration_at');
        const expirationTime = new Date(expiration_at).getTime();
        const now = new Date().getTime();

        if (expirationTime <= now && token) {
          // Token is expired, dispatch logout
          dispatch(logout());
        }
        
      };

      // Set interval to check token expiration every minute (adjust as needed)
      setInterval(checkTokenExpiration, 60000);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.loggedIn, session.user]);

  return (
    <>
      <div className="topNav">
        <div className="text-center">
          <Image src="/assets/images/premier-nx-logo.png" />
        </div>
        <MainLoader />
      </div>
    </>
  );
};

export default TopNav;
